<template>
	<el-dialog
		title="采购"
		top="4vh"
		:visible.sync="dialogTableVisible"
		width="90%"
		:show-close="false"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
	>
		<el-row class="border-bottom padding">
			<el-col style="color:red;"
				>注意事项：仓库流转中心按照提交的采购方案进行订单核对，所以在提交采购方案之前请认真确认库存匹配的种类和数量以及采购单据的数量，提交之后采购单据的数量将无法进行增减，缺少采购单将按照当前方案直接发货，多余采购单未填写信息将无法完成入库。</el-col
			>
			<el-col style="margin:10px 0;">
				<span style="font-weight:900;">ID：{{ sondata.orderId }}</span>
				<span style="margin-left:20px;font-weight: 900;">订单号：{{ sondata.amazonOrderId }}</span>
				<span style="margin-left:20px;font-weight: 900;">国家：{{ sondata.countryName }}</span>
				<span style="margin-left:20px;font-weight: 900;">平台：{{ sondata.sourceclass }}</span>
				<!-- <el-button style="margin-left:20px;" type="primary" @click="savePurchaseSkuData">批量保存sku和采购链接映射关系</el-button>
				<el-button style="margin-left:20px;" type="primary" @click="setAllPurchaseUrl">采购链接同首个sku</el-button> -->
			</el-col>
			<div
				class="product"
				v-for="(item, index) in sondata.productInfos"
				:key="index"
			>
				<div class="img-box">
					<div class="demo-image__preview">
						<el-image
							style="width: 150px; height: 150px"
							:src="item.imageUrl"
							:preview-src-list="[item.imageUrl]"
						>
						</el-image>
					</div>
				</div>
				<div class="product-info">
					<div class="title line-height">
						<a
							target="_blank"
							class="linkto"
							:href="item.sourceLink"
							>{{ item.title }}</a
						>
						<el-button type="text" icon="el-icon-copy-document" @click="myCopyText(item.title)"></el-button>
						<el-button
							type="primary"
							@click="visibleProductLink(item.sku)"
							>查看货源</el-button
						>
					</div>
					<div class="info line-height sku-title">
						<span class="mr40">SKU：{{ item.sku }}</span>
						<span class="mr40">数量：{{ item.quantityOrdered }}</span>
						<el-button class="mr40" v-if="isSamePerson(item.sku)" @click="addPurchase(item.sku)" type="primary">添加采购信息</el-button>
						<el-button class="mr40" @click="addNewGroupPurchase(item.sku)" type="primary">添加一组新的采购信息/查询历史采购信息</el-button>
						<!-- <template v-if="purchaseSkuData[item.sku] && purchaseSkuData[item.sku].length > 0 && purchaseSkuData[item.sku][0]['id']">
							<div style="margin-left: 10px">
								当前启用状态：
								<span :class="purchaseSkuData[item.sku][0]['isUse'] == '1' ? 'success-text' : 'error-text'">
									{{ purchaseSkuData[item.sku][0]['isUse'] == '1' ? '启用' : '停用' }}
								</span>
							</div>
							<el-button class="mr40" type="text" @click="changeGroupIsUse(purchaseSkuData[item.sku][0])">{{ purchaseSkuData[item.sku][0]['isUse'] == '1' ? '停用' : '启用' }}</el-button>
							<div>当前自动填写采购需求状态：
								<span :class="purchaseSkuData[item.sku][0]['status'] == '1' ? 'success-text' : 'error-text'">{{ purchaseSkuData[item.sku][0]['status'] == '1' ? '开启' : '关闭' }}</span>
							</div>
							<el-button type="text" @click="changeGroupStatus(purchaseSkuData[item.sku][0])">{{ purchaseSkuData[item.sku][0]['status'] == '1' ? '关闭' : '开启' }}</el-button>
						</template> -->
					</div>
					<div class="purchase-input-box">
						<div class="purchase-content">
							<div class="purchase-row" v-for="(item1, index1) in (purchaseSkuData[item.sku] || [])" :key="index1">
								<div class="item">
									<el-input
										:disabled="UserInfo.uid == item1.uid || !item1.id ? false : true"
										placeholder="采购链接"
										v-model="item1.purchaseDetailUrl" style="width: 280px;" class="purchase-url-input">
										<div slot="suffix">
											<el-button  type="text"  @click="useExistLink(item1, item.sku)">引用链接</el-button>
											<el-button type="text"  @click="parseLink(item1)">解析</el-button>
											<el-button type="text"  @click="gotoDetail(item1.purchaseDetailUrl)">跳转</el-button>
										</div>
									</el-input>
								</div>
								<div class="item">
									<el-select :disabled="UserInfo.uid == item1.uid || !item1.id ? false : true" v-model="item1.purchaseDetailSku" placeholder="采购链接中的sku" style="width: 150px" clearable creatable filterable @change="skuChange(item1)" allow-create :ref="item1.ref">
										<el-option
											v-for="option in (item1.purchaseDetailUrl ? skuOptionsMap[item1.purchaseDetailUrl] ? skuOptionsMap[item1.purchaseDetailUrl] : [] : [])"
											:key="option"
											:label="option"
											:value="option"
										></el-option>
									</el-select>
								</div>
								<div class="item">
									<el-input :disabled="UserInfo.uid == item1.uid || !item1.id ? false : true" v-model="item1.purchaseNum" placeholder="数量" style="width: 80px" type="number" />
								</div>
								<div class="item">
									<el-input :disabled="UserInfo.uid == item1.uid || !item1.id ? false : true" v-model="item1.supplierName" placeholder="供应商" style="width: 200px" />
								</div>
								<div class="item">
									<el-input :disabled="UserInfo.uid == item1.uid || !item1.id ? false : true" v-model="item1.price" placeholder="价格" style="width: 100px">
										<div slot="suffix">
											￥
										</div>
									</el-input>
								</div>
								<div class="item">
									<el-input :disabled="UserInfo.uid == item1.uid || !item1.id ? false : true" v-model="item1.remark" placeholder="备注" style="width: 200px" />
								</div>
								<!-- <div class="item">
									<el-select v-model="item1.status" placeholder="是否自动采购" style="width: 120px" clearable disabled>
										<el-option label="自动采购" value="1"></el-option>
										<el-option label="取消自动采购" value="0"></el-option>
									</el-select>
								</div> -->
								<el-button type="success" v-if="!item1.id || UserInfo.uid == item1.uid" @click="submitPurchase(item1, index1, item.sku, true)">保存</el-button>
								<el-button type="danger" v-if="!item1.id || UserInfo.uid == item1.uid" @click="delPurchase(item1, index1, item.sku)">删除</el-button>
							</div>
						</div>
					</div>
				</div>
				</div>
			<div>采购要求：{{ sondata.purchaseDemand }}</div>
		</el-row>
		<el-row style="margin-top:10px;">
			<el-button
				type="primary"
				:loading="btnloading"
				@click="matching"
				:disabled="btndisabled"
				>匹配库存</el-button
			>
			<el-button
				type="primary"
				:loading="btnloading"
				@click="HXShops"
				:disabled="btndisabled"
				>海逊商城</el-button
			>
			<el-button
				type="primary"
				v-if="showTuiBool"
				@click="handleTuiTable"
				:disabled="btndisabled"
				>海外退件匹配</el-button
			>
		</el-row>
		<el-row style="margin-top:10px;">
			<el-table :data="ReturninventoryList" border style="width: 100%">
				<el-table-column
					prop="inventoryNumber"
					label="库存编号"
					align="center"
				></el-table-column>
				<el-table-column label="图片" align="center" width="90">
					<template slot-scope="scope">
						<img
							:src="scope.row.images"
							alt=""
							style="width:60px;height:60px;"
						/>
					</template>
				</el-table-column>
				<el-table-column
					prop="productFullName"
					label="全称"
					align="center"
				></el-table-column>
				<el-table-column
					prop="productSimpleName"
					label="简称"
					align="center"
				></el-table-column>
				<el-table-column
					prop="inventorySku"
					label="规格尺寸"
					align="center"
				></el-table-column>
				<el-table-column
					prop="productDescription"
					label="描述"
					align="center"
				></el-table-column>
				<el-table-column
					prop="actualCount"
					label="库存数量"
					align="center"
					width="80"
				></el-table-column>
				<el-table-column label="使用数量" align="center" width="160">
					<template slot-scope="scope">
						<el-input-number
							v-model="scope.row.useCount"
							:disabled="btndisabled"
							:min="1"
							:max="scope.row.actualCount"
							size="mini"
						></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="核对备注" align="center">
					<template slot-scope="scope">
						<el-input
							type="textarea"
							v-model="scope.row.purchaseDemandRemark"
							:disabled="btndisabled"
						></el-input>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					align="center"
					width="80"
					fixed="right"
				>
					<template slot-scope="scope">
						<el-button
							type="danger"
							@click="delSave(scope.row)"
							:disabled="btndisabled"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
		</el-row>

		<el-row style="margin-top:10px;">
			<el-table :data="ReturninventoryList1" border style="width: 100%">
				<el-table-column label="图片" align="center" width="90">
					<template slot-scope="scope">
						<img
							:src="scope.row.images"
							alt=""
							style="width:60px;height:60px;"
						/>
					</template>
				</el-table-column>
				<el-table-column
					prop="productFullName"
					label="全称"
					align="center"
				></el-table-column>
				<el-table-column
					prop="productSimpleName"
					label="简称"
					align="center"
				></el-table-column>
				<el-table-column
					prop="inventorySku"
					label="规格尺寸"
					align="center"
				></el-table-column>
				<el-table-column
					prop="productDescription"
					label="描述"
					align="center"
				></el-table-column>
				<el-table-column
					prop="originalPrice"
					label="原价"
					align="center"
				></el-table-column>
				<el-table-column
					prop="currentPrice"
					label="现价"
					align="center"
				></el-table-column>
				<el-table-column
					prop="actualCount"
					label="库存数量"
					align="center"
					width="80"
				></el-table-column>
				<el-table-column label="使用数量" align="center" width="160">
					<template slot-scope="scope">
						<el-input-number
							v-model="scope.row.useCount"
							:disabled="btndisabled"
							:min="1"
							:max="scope.row.actualCount"
							size="mini"
						></el-input-number>
					</template>
				</el-table-column>
				<el-table-column label="核对备注" align="center">
					<template slot-scope="scope">
						<el-input
							type="textarea"
							v-model="scope.row.purchaseDemandRemark"
							:disabled="btndisabled"
						></el-input>
					</template>
				</el-table-column>
				<el-table-column
					label="操作"
					align="center"
					width="80"
					fixed="right"
				>
					<template slot-scope="scope">
						<el-button
							type="danger"
							@click="delSave1(scope.row)"
							:disabled="btndisabled"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
		</el-row>

		<el-row style="margin-top:10px;">
			<el-table :data="tuiTable" border style="width: 100%" :header-cell-style="{ textAlign: 'center' }">
				<el-table-column width="80" prop="id" label="退仓ID" align="center" />
				<el-table-column align="left" label="商品信息" width="350">
					<template slot-scope="scope">
						<div
							class="details"
							v-for="(item, index) in scope.row.orderInfo.orderItems"
							:key="index"
						>
							<div class="details_left" style="margin-right: 18px">
								<el-popover
									trigger="hover"
									placement="right"
									prop="orderItems.imageUrl"
									v-if="item.imageUrl"
								>
									<img
										referrer="no-referrer|origin|unsafe-url"
										:src="item.imageUrl"
										alt
										style="width:500px;height:500px;"
									/>
									<div class="scope_img" slot="reference">
										<img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
									</div>
								</el-popover>
								<el-button
									type="text"
									size="mini"
									v-else
									@click="getOriginalImg(item)"
									style="padding: 0;"
									>查看原图</el-button
								>
							</div>
							<div class="details_right">
								<div
									style="width: 100%;"
									v-if="item.title !== null"
									class="textlang"
									:title="item.title"
								>
									<strong style="color:black">商品简称:</strong> {{ item.title }}
								</div>
								<div style="width: 100%;" v-show="item.systemSku">
									<strong style="color:black">系统SKU:</strong> {{ item.systemSku }}
								</div>
								<div style="width: 100%;">
									<strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
								</div>
								<div style="width: 100%;" v-show="item.productSku">
									<strong style="color:black">产品SKU:</strong> {{ item.productSku }}
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="productDescription" label="订单信息" align="left" width="220">
					<template slot-scope="scope">
						<div
							class="details"
						>
							<div class="details_right" style="width: 100%">
								<div style="width: 100%;">
									<strong style="color:black">原订单号:</strong> {{ scope.row.orderInfo.amazonOrderId }}
								</div>
								<div style="width: 100%;">
									<strong style="color:black">原订单ID:</strong> {{ scope.row.orderInfo.id }}
								</div>
								<div style="width: 100%;">
									<strong style="color:black">退件条码:</strong> {{ scope.row.returnBarcode }}
								</div>
								<div style="width: 100%;">
									<strong style="color:black">原转单号:</strong> {{ scope.row.oldConveyNumber }}
								</div>
								<div style="width: 100%;">
									<strong style="color:black">渠道ID:</strong> {{ scope.row.orderChannelId }}
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="countryName" label="国家" align="center" width="180"></el-table-column>
				<el-table-column prop="reassignTime" label="重派时间" align="center"></el-table-column>
				<el-table-column
					label="操作"
					align="center"
					width="180"
					fixed="right"
				>
					<template slot-scope="scope">
						<el-button
							type="primary"
							@click="handleTui(scope.row.id)"
							:disabled="btndisabled"
							>回退匹配</el-button
						>
					</template>
				</el-table-column>
			</el-table>
		</el-row>

		<el-row class="padding">
			<el-button
				type="primary"
				@click="AddPurchaselist"
				v-if="system === 5"
				:disabled="btndisabled"
				>新增</el-button
			>
			<el-button
				type="primary"
				@click="AddAllPurchaselist"
				v-if="system === 5 && showTuiBool"
				:disabled="btndisabled"
				>批量新增</el-button
			>
		</el-row>

		<!-- 采购单详情 -->
		<div v-for="(itemValue, index) in obj" :key="index">
			<el-row class="border-bottom padding">
				<el-col :span="20"
					>采购单据号：{{ itemValue.purchaseNumber }}</el-col
				>

				<el-col :span="20">
					<el-row>
						<el-col class="padding" :span="20">
							<el-input
								v-model="itemValue.purchaseModel"
								disabled
							>
								<template slot="prepend">
									<el-tooltip
										content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input
								v-model="itemValue.purchasePrice"
								disabled
							>
								<template slot="prepend">
									采购价:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="itemValue.rebatePrice" disabled>
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="5">
							<el-input v-model="itemValue.actualRefund" disabled>
								<template slot="prepend">
									<el-tooltip
										content="采购平台退回的钱"
										placement="top"
									>
										<el-button>实际退款:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="itemValue.otherPrice" disabled>
								<template slot="prepend">
									<el-tooltip
										content="采购员给运营实际退回的钱"
										placement="top"
									>
										<el-button>退款费用:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input
								v-model="itemValue.purchaseTypeCode"
								disabled
							>
								<template slot="prepend">
									类型:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input
								v-model="itemValue.logisticsCompany"
								disabled
							>
								<template slot="prepend">
									物流公司
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="10">
							<el-input
								v-model.trim="itemValue.internalConveyNumber"
								disabled
							>
								<template slot="prepend">
									运单号码:
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="itemValue.remark" disabled>
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="4" v-if="itemValue.system == 5">
					<el-col class="padding">
						<el-button type="primary" @click="Editor(itemValue)"
							>编辑</el-button
						>
						<el-button
							type="danger"
							@click="Purchasedel(itemValue.id)"
							:disabled="btndisabled"
							>删除</el-button
						>
					</el-col>
				</el-col>
			</el-row>
		</div>
		<el-collapse>
			<el-collapse-item title="操作日志" name="1">
				<el-timeline>
					<el-timeline-item
						v-for="(activity, index) in activities"
						:key="index"
						:timestamp="activity.createTime"
					>
						{{ activity.operateName }}
					</el-timeline-item>
				</el-timeline>
			</el-collapse-item>
		</el-collapse>
		<div slot="footer" class="dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="submit" :disabled="btndisabled"
				>提 交</el-button
			>
		</div>

		<el-dialog
			title="海逊商城"
			:visible.sync="Hymall"
			width="50%"
			append-to-body
		>
			<div>
				<el-input v-model="ShopsString" style="width:82%;"></el-input>
				<el-button
					type="primary"
					style="margin-left:10px;"
					@click="HXShopsSearch"
					>搜索</el-button
				>
				<el-button type="primary" @click="HXShopsReset">重置</el-button>
			</div>
			<div style="margin-top:15px;">
				<el-table
					:data="GoodsMall"
					border
					style="width: 100%"
					@selection-change="handleSelectionChange2"
					v-loading="tableLoading2"
				>
					<el-table-column
						type="selection"
						width="55"
					></el-table-column>
					<el-table-column label="图片" align="center" width="90">
						<template slot-scope="scope">
							<el-image
								style="width: 60px; height: 60px"
								:src="scope.row.imagesList[0]"
								:preview-src-list="scope.row.imagesList"
							>
							</el-image>
						</template>
					</el-table-column>
					<el-table-column
						prop="productFullName"
						label="全称"
						align="center"
					></el-table-column>
					<el-table-column
						prop="productSimpleName"
						label="简称"
						align="center"
					></el-table-column>
					<el-table-column
						prop="originalPrice"
						label="原价"
						align="center"
					></el-table-column>
					<el-table-column
						prop="currentPrice"
						label="现价"
						align="center"
					></el-table-column>
					<el-table-column
						prop="productDescription"
						label="描述"
						align="center"
					></el-table-column>
					<el-table-column
						prop="actualCount"
						label="库存数量"
						align="center"
					></el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<div>
					<el-button @click="Hymall = false">关闭</el-button>
					<el-button type="primary" @click="save1">保存</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog
			top="5vh"
			width="45%"
			title="库存"
			:visible.sync="innerVisibles"
			append-to-body
		>
			<el-tabs v-model="activeName" type="card">
				<el-tab-pane label="全部库存" name="first">
					<el-input
						v-model="searchString"
						placeholder="库存编号、商品全称、商品简称"
						style="width:70%;"
					></el-input>
					<el-button
						type="primary"
						style="margin-left:15px;"
						@click="matchingAjaxSearch"
						>搜索</el-button
					>
					<el-table
						:data="inventoryList"
						border
						height="550"
						style="width: 100%;margin-top:15px;"
						@selection-change="handleSelectionChange1"
						v-loading="tableLoading1"
					>
						<el-table-column
							type="selection"
							width="55"
						></el-table-column>
						<el-table-column
							prop="inventoryNumber"
							label="库存编号"
							align="center"
						></el-table-column>
						<el-table-column label="图片" align="center" width="90">
							<template slot-scope="scope">
								<el-image
									style="width: 60px; height: 60px"
									:src="scope.row.imagesList[0]"
									:preview-src-list="scope.row.imagesList"
								>
								</el-image>
							</template>
						</el-table-column>
						<el-table-column
							prop="productFullName"
							label="全称"
							align="center"
						></el-table-column>
						<el-table-column
							prop="productSimpleName"
							label="简称"
							align="center"
						></el-table-column>
						<el-table-column
							prop="inventorySku"
							label="规格尺寸"
							align="center"
						></el-table-column>
						<el-table-column
							prop="productDescription"
							label="描述"
							align="center"
						></el-table-column>
						<el-table-column
							prop="actualCount"
							label="库存数量"
							align="center"
							width="80"
						></el-table-column>
					</el-table>
					<el-pagination
						style="text-align: center;margin-top:10px;"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="[20, 50, 100, 200]"
						:page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-tab-pane>
				<el-tab-pane label="已匹配库存" name="second">
					<el-table
						:data="inventoryList1"
						border
						height="550"
						style="width: 100%;margin-top:15px;"
						@selection-change="handleSelectionChange_1"
						v-loading="tableLoading1"
					>
						<el-table-column
							type="selection"
							width="55"
						></el-table-column>
						<el-table-column
							prop="inventoryNumber"
							label="库存编号"
							align="center"
						></el-table-column>
						<el-table-column label="图片" align="center" width="90">
							<template slot-scope="scope">
								<el-image
									style="width: 60px; height: 60px"
									:src="scope.row.imagesList[0]"
									:preview-src-list="scope.row.imagesList"
								>
								</el-image>
							</template>
						</el-table-column>
						<el-table-column
							prop="productFullName"
							label="全称"
							align="center"
						></el-table-column>
						<el-table-column
							prop="productSimpleName"
							label="简称"
							align="center"
						></el-table-column>
						<el-table-column
							prop="inventorySku"
							label="规格尺寸"
							align="center"
						></el-table-column>
						<el-table-column
							prop="productDescription"
							label="描述"
							align="center"
						></el-table-column>
						<el-table-column
							prop="actualCount"
							label="库存数量"
							align="center"
							width="80"
						></el-table-column>
					</el-table>
					<el-pagination
						style="text-align: center;margin-top:10px;"
						@size-change="handleSizeChange1"
						@current-change="handleCurrentChange1"
						:current-page="currentPage1"
						:page-sizes="[20, 50, 100, 200]"
						:page-size="pagesize1"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total1"
					></el-pagination>
				</el-tab-pane>
			</el-tabs>

			<div slot="footer" class="dialog-footer">
				<div>
					<el-button @click="innerVisibles = false">关闭</el-button>
					<el-button type="primary" @click="save">保存</el-button>
				</div>
			</div>
		</el-dialog>

		<!-- 添加采购单 -->
		<el-dialog
			width="54%"
			top="30vh"
			title="新增采购单"
			:visible.sync="AddinnerVisible"
			append-to-body
		>
			<el-row class="border-bottom padding">
				<el-col :span="25">
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="purchaseModel1">
								<template slot="prepend">
									<el-tooltip
										content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input v-model="purchasePrice1">
								<template slot="prepend">
									采购价:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="rebatePrice1">
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="5">
							<el-input v-model="actualRefund1">
								<template slot="prepend">
									实际退款:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="otherPrice1">
								<template slot="prepend">
									退款费用:
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<span class="leix">类型:</span>
							<el-select
								v-model="purchaseTypeCode1"
								placeholder="请选择"
								style="width: 77%;"
								@change="shopChange1"
								class="logistics"
							>
								<el-option
									v-for="item in selectType"
									:key="item.value"
									:label="item.itemTypeName"
									:value="item.itemTypeName"
								></el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="5">
							<span class="leix">物流公司:</span>
							<el-select
								v-model="logisticsCompany1"
								@change="SelectTrack17Logistics1"
								value-key="id"
								filterable
								clearable
								placeholder="请选择"
								style="width: 63%;"
								class="logistics"
							>
								<el-option
									v-for="item in Track17Logistics"
									:key="item.id"
									:label="item.nameCn"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="10">
							<el-input v-model.trim="internalConveyNumber1" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
								<template slot="prepend">
									运单号码:
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="internalConveyNumber1">
						<el-col :span="6" :offset="0">
							<strong>包裹总计包含：</strong>
							<el-input-number v-model="estimatedQuantity1" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						<el-col :span="12" :offset="0">
							<strong>该单据使用商品：</strong>
							<el-input-number v-model="useQuantity1" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="remark1">
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
			</el-row>

			<div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="AddPurchaseb"
					:loading="isLoading"
					>保存</el-button
				>
				<el-button @click="AddPurchasebCancel">取消</el-button>
			</div>
		</el-dialog>

		<el-dialog
			width="56%"
			top="5vh"
			title="批量新增采购单"
			:visible.sync="AddAllinnerVisible"
			append-to-body
		>
			<el-row class="border-bottom padding">
				<el-col :span="25">
					<el-row :gutter="20">
						<el-col class="padding" :span="15">
							<el-input v-model="purchaseModel1">
								<template slot="prepend">
									<el-tooltip
										content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="teshu">
								<template slot="prepend">
									<el-button>分割符:</el-button>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="4">
							<el-button type="success" @click="setAllPurchaseb">生成多个采购单</el-button>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input v-model="purchasePrice1">
								<template slot="prepend">
									采购价:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="rebatePrice1">
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="5">
							<el-input v-model="actualRefund1">
								<template slot="prepend">
									实际退款:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="otherPrice1">
								<template slot="prepend">
									退款费用:
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<span class="leix">类型:</span>
							<el-select
								v-model="purchaseTypeCode1"
								placeholder="请选择"
								style="width: 77%;"
								@change="shopChange1"
								class="logistics"
							>
								<el-option
									v-for="item in selectType"
									:key="item.value"
									:label="item.itemTypeName"
									:value="item.itemTypeName"
								></el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="5">
							<span class="leix">物流公司:</span>
							<el-select
								v-model="logisticsCompany1"
								@change="SelectTrack17Logistics1"
								value-key="id"
								filterable
								clearable
								placeholder="请选择"
								style="width: 63%;"
								class="logistics"
							>
								<el-option
									v-for="item in Track17Logistics"
									:key="item.id"
									:label="item.nameCn"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="10">
							<el-input v-model.trim="internalConveyNumber1" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
								<template slot="prepend">
									运单号码:
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="internalConveyNumber1">
						<el-col :span="6" :offset="0">
							<strong>包裹总计包含：</strong>
							<el-input-number v-model="estimatedQuantity1" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						<el-col :span="12" :offset="0">
							<strong>该单据使用商品：</strong>
							<el-input-number v-model="useQuantity1" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="remark1">
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<el-divider />
			<el-row class="border-bottom padding" v-for="(item, i) in purchaseAllList" :key="i+'ww'">
				<el-col :span="25">
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="item.purchaseModel">
								<template slot="prepend">
									<el-tooltip
										content="完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input v-model="item.purchasePrice">
								<template slot="prepend">
									采购价:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="item.rebatePrice">
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>

						<el-col class="padding" :span="5">
							<el-input v-model="item.actualRefund">
								<template slot="prepend">
									实际退款:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="item.otherPrice">
								<template slot="prepend">
									退款费用:
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<span class="leix">类型:</span>
							<el-select
								v-model="item.purchaseTypeCode"
								placeholder="请选择"
								style="width: 77%;"
								@change="shopChange1"
								class="logistics"
							>
								<el-option
									v-for="item in selectType"
									:key="item.value"
									:label="item.itemTypeName"
									:value="item.itemTypeName"
								></el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="5">
							<span class="leix">物流公司:</span>
							<el-select
								v-model="item.logisticsCompany"
								@change="SelectTrack17Logistics1"
								value-key="id"
								filterable
								clearable
								placeholder="请选择"
								style="width: 63%;"
								class="logistics"
							>
								<el-option
									v-for="item in Track17Logistics"
									:key="item.id"
									:label="item.nameCn"
									:value="item"
								>
								</el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="10">
							<el-input v-model.trim="item.internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')">
								<template slot="prepend">
									运单号码:
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="item.internalConveyNumber">
						<el-col :span="6" :offset="0">
							<strong>包裹总计包含：</strong>
							<el-input-number v-model="item.estimatedQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						<el-col :span="12" :offset="0">
							<strong>该单据使用商品：</strong>
							<el-input-number v-model="item.useQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="item.remark">
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="AddAllPurchaseb"
					:loading="isAllLoading"
					>保存</el-button
				>
				<el-button @click="AddAllinnerVisible=false">取消</el-button>
			</div>
		</el-dialog>

		<!-- 编辑采购单 -->
		<el-dialog
			width="54%"
			top="30vh"
			title="采购编辑"
			:visible.sync="innerVisible"
			append-to-body
		>
			<el-row class="border-bottom padding">
				<el-col :span="20">采购单据号：{{ purchaseNumber }}</el-col>

				<el-col :span="25">
					<el-row>
						<el-col class="padding" :span="20">
							<el-input
								v-model="purchaseModel"
								:disabled="isDisabled"
							>
								<template slot="prepend">
									<el-tooltip
										:content="isContens"
										placement="top"
									>
										<el-button>海逊仓库核对详情:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col class="padding" :span="5">
							<el-input v-model="purchasePrice">
								<template slot="prepend">
									采购价:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="rebatePrice">
								<template slot="prepend">
									<el-tooltip
										content="购买后,卖家返回的佣金"
										placement="top"
									>
										<el-button>返佣:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="actualRefund">
								<template slot="prepend">
									实际退款:
								</template>
							</el-input>
						</el-col>
						<el-col class="padding" :span="5">
							<el-input v-model="otherPrice">
								<template slot="prepend">
									退款费用:
								</template>
							</el-input>
						</el-col>
					</el-row>

					<el-row>
						<el-col class="padding" :span="5">
							<span class="leix">类型:</span>
							<el-select
								v-model="purchaseTypeCode"
								placeholder="请选择"
								style="width: 77%;"
								@change="shopChange"
								class="logistics"
							>
								<el-option
									v-for="item in selectType"
									:key="item.value"
									:label="item.itemTypeName"
									:value="item.itemTypeName"
								></el-option>
							</el-select>
						</el-col>
						<el-col class="padding" :span="5">
							<span class="leix">物流公司:</span>
							<el-tooltip
								class="item"
								effect="dark"
								:content="isContent"
								placement="top-start"
							>
								<el-select
									v-model="logisticsCompany"
									:disabled="isDisabled"
									@change="SelectTrack17Logistics"
									value-key="id"
									filterable
									clearable
									placeholder="请选择"
									style="width: 57%;"
									class="logistics"
								>
									<el-option
										v-for="item in Track17Logistics"
										:key="item.id"
										:label="item.nameCn"
										:value="item"
									>
									</el-option>
								</el-select>
							</el-tooltip>
						</el-col>
						<el-col class="padding" :span="10">
							<el-tooltip
								class="item"
								effect="dark"
								:content="isContent"
								placement="top-start"
							>
								<el-input
									v-model.trim="internalConveyNumber" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')"
									:disabled="isDisabled"
								>
									<template slot="prepend">
										运单号码:
									</template>
								</el-input>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-row :gutter="20" v-show="internalConveyNumber">
						<el-col :span="6" :offset="0">
							<strong>包裹总计包含：</strong>
							<el-input-number v-model="estimatedQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
						<el-col :span="12" :offset="0">
							<strong>该单据使用商品：</strong>
							<el-input-number v-model="useQuantity" size="small" :min="1" :step="1">
							</el-input-number>
						</el-col>
					</el-row>
					<el-row>
						<el-col class="padding" :span="20">
							<el-input v-model="remark">
								<template slot="prepend">
									<el-tooltip
										content="填写对应的采购平台的订单号，方便补充运单号，此备注仅自己可见"
										placement="top"
									>
										<el-button>采购备注:</el-button>
									</el-tooltip>
								</template>
							</el-input>
						</el-col>
					</el-row>
				</el-col>
			</el-row>

			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="Purchaseb()">保存</el-button>
				<el-button @click="innerVisible = false">取消</el-button>
			</div>
		</el-dialog>

		<el-dialog
			title="货源链接"
			:visible.sync="dialogInnerVisible"
			append-to-body
			width="35%"
		>
			<el-form>
				<el-form-item label>
					<el-row
						type="flex"
						align="middle"
						v-for="(item, index) in productLinkList"
						:key="item.id"
					>
						<el-col :span="18">
							<el-input
								placeholder="请输入内容"
								v-model="item.value"
								style="margin-right:10px"
							></el-input>
						</el-col>
						<el-button type="primary" @click="openLink(item.value)"
							>访问链接</el-button
						>
						<el-button
							type="danger"
							@click="edit_blue_del(index)"
							icon="el-icon-close"
							v-show="productLinkList.length > 1"
						></el-button>
					</el-row>
					<span style="color:#F56C6C"
						>此链接记录货源链接，可填写1-5条，非必填。</span
					>
				</el-form-item>
			</el-form>
			<el-button type="primary" @click="edit_blue_point"
				>增加一条记录</el-button
			>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogInnerVisible = false">取 消</el-button>
				<el-button
					type="primary"
					@click="addProductLink"
					:loading="loading === 'dialogInnerVisible'"
				>
					确 定
				</el-button>
			</div>
		</el-dialog>

		<el-dialog
			top="5vh"
			width="60%"
			title="海外仓未匹配退件"
			:visible.sync="tuiVisibles"
			append-to-body
		>
			<el-input
				v-model="searchString1"
				placeholder="退件条码、原转单号、渠道ID"
				style="width:22%;margin-right: 20px;"
			></el-input>
			<el-input
				v-model.trim="purchaseDemand"
				placeholder="请输入采购需求或核对详情"
				style="width:22%;margin-right: 20px;"
			></el-input>
			<el-select v-model="countryMark" placeholder="请选择国家" clearable filterable>
				<el-option v-for="item in countryList" :key="item.id" :label="item.countryName" :value="item.countryCode"></el-option>
			</el-select>
			<el-input v-model.trim="variantSku" placeholder="请输入商品主SKU" style="width:22%;margin-right: 20px;margin-left: 20px;"></el-input>
			<el-input v-model.trim="sellerSku" placeholder="请输入SKU" style="width:22%;margin-right: 20px;margin-top: 20px;"></el-input>
			<el-button
				type="primary"
				style="margin-left:15px;"
				@click="seachHandleTuiTable"
				>搜索</el-button
			>
			<el-button
				style="margin-left:15px;"
				@click="handleResetTable"
				>重置</el-button
			>
			<el-table
				:data="tuiDialogList"
				border
				max-height="550"
				style="width: 100%;margin-top:15px;"
				@selection-change="handleSelectionChange3"
				v-loading="tableLoading3"
				:header-cell-style="{ textAlign: 'center' }"
			>
			<el-table-column type="selection" width="55" align="center" ></el-table-column>
			<el-table-column width="80" prop="id" label="商品ID" align="center" />
			<el-table-column align="left" label="商品信息" width="250">
				<template slot-scope="scope">
					<div v-if="scope.row.orderInfo && scope.row.orderInfo.orderItems">
						<div
							class="details"
							v-for="(item, index) in scope.row.orderInfo.orderItems"
							:key="index"
						>
							<div class="details_left" style="margin-right: 20px">
								<el-popover
									trigger="hover"
									placement="right"
									prop="orderItems.imageUrl"
									v-if="item.imageUrl"
								>
									<img
										referrer="no-referrer|origin|unsafe-url"
										:src="item.imageUrl"
										alt
										style="width:500px;height:500px;"
									/>
									<div class="scope_img" slot="reference">
										<img referrer="no-referrer|origin|unsafe-url" :src="item.imageUrl" alt />
									</div>
								</el-popover>
								<el-button
									type="text"
									size="mini"
									v-else
									@click="getOriginalImg(item)"
									style="padding: 0;"
									>查看原图</el-button
								>
							</div>
							<div class="details_right">
								<div
									style="width: 100%;"
									v-if="item.title !== null"
									class="textlang"
									:title="item.title"
								>
									<strong style="color:black">商品简称:</strong> {{ item.title }}
								</div>
								<div style="width: 100%;" v-show="item.systemSku">
									<strong style="color:black">系统SKU:</strong> {{ item.systemSku }}
								</div>
								<div style="width: 100%;">
									<strong style="color:black">SKU:</strong> {{ item.sellerSKU }}
								</div>
								<div style="width: 100%;" v-show="item.variantSku">
									<strong style="color:black">商品主SKU:</strong> {{ item.variantSku }}
								</div>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="productDescription" label="订单信息" align="left" width="220">
				<template slot-scope="scope">
					<div
						class="details"
					>
						<div class="details_right" style="width: 100%">
							<div style="width: 100%;" v-if="scope.row.orderInfo && scope.row.orderInfo.orderItems && scope.row.orderInfo.orderItems.length">
								<strong style="color:black">原订单号:</strong> {{ scope.row.orderInfo.orderItems[0].amazonOrderId }}
							</div>
							<div style="width: 100%;" v-if="scope.row.orderInfo">
								<strong style="color:black">原订单ID:</strong> {{ scope.row.orderInfo.id }}
							</div>
							<div style="width: 100%;" v-if="scope.row.returnBarcode">
								<strong style="color:black">退件条码:</strong> {{ scope.row.returnBarcode }}
							</div>
							<div style="width: 100%;" v-if="scope.row.oldConveyNumber">
								<strong style="color:black">原转单号:</strong> {{ scope.row.oldConveyNumber }}
							</div>
							<div style="width: 100%;" v-if="scope.row.channelName">
								<strong style="color:black">渠道:</strong> {{ scope.row.channelName }}
							</div>
							<div style="width: 100%;" v-if="scope.row.orderChannelId">
								<strong style="color:black">渠道ID:</strong> {{ scope.row.orderChannelId }}
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="productSimpleName" label="采购需求" align="center" width="150">
				<template slot-scope="scope">
					<div v-if="scope.row.orderInfo && scope.row.orderInfo.purchaseDemands">
						<div
							class="details"
							v-for="(item, index) in scope.row.orderInfo.purchaseDemands"
							:key="index"
						>
							<div class="details_right" style="width: 100%">
								<div style="width: 100%;">
									<pre style="white-space: pre-wrap;">{{ item.purchaseDemand }}</pre>
								</div>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="productSimpleName" label="核对详情" align="center" width="150">
				<template slot-scope="scope">
					<div v-if="scope.row.orderInfo && scope.row.orderInfo.purchaseDemands">
						<div
							class="details"
							v-for="(item, index) in scope.row.orderInfo.purchaseDemands"
							:key="index+'vv'"
						>
							<div class="details_right" style="width: 100%">
								<div
									style="width: 100%;"
									v-for="(ele, i) in item.purchaseItems"
									:key="i+'dd'"
								>
									<pre style="white-space: pre-wrap; margin-right: 6px; display: inline;" :style="ele.invalidStatus===0?'color:red;':''">{{ ele.purchaseModel }}</pre>
									<el-tag type="danger" size="mini" v-if="ele.invalidStatus===0">无效</el-tag>
								</div>
							</div>
						</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="countryName" label="国家" align="center" width="80"></el-table-column>
			<el-table-column prop="destroyTime" sortable label="销毁时间" align="center" width="110"></el-table-column>
			</el-table>
			<el-pagination
				v-if="tuiVisibles"
				style="text-align: center;margin-top:10px;"
				@size-change="handleSizeChange2"
				@current-change="handleCurrentChange2"
				:current-page="currentPage2"
				:page-sizes="[20, 50, 100, 200, 400]"
				:page-size="pagesize2"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total2"
			></el-pagination>

			<div slot="footer" class="dialog-footer">
				<div>
					<el-button @click="tuiVisibles = false">关 闭</el-button>
					<el-button type="primary" @click="submitTui" :loading="tuiBtnLoading">提 交</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog
			title="采购信息详情"
			:visible.sync="showNewGroupPurchaseDialog"
			append-to-body
			width="80%"
		>
			<el-button @click="addGroupPurchase" type="primary">添加一行</el-button>
			<el-button @click="saveGroupPurchase" type="primary">保存组数据</el-button>
			<div class="purchase-content">
				<div class="purchase-row" v-for="(item1, index1) in groupPurchaseSkuData" :key="index1">
					<el-checkbox v-model="item1.checked"></el-checkbox>
					<div class="item">
						<el-input
							placeholder="采购链接"
							v-model="item1.purchaseDetailUrl" style="width: 280px;" class="purchase-url-input">
							<div slot="suffix">
								<el-button  type="text"  @click="useExistLink(item1, addGroupSku)">引用链接</el-button>
								<el-button type="text"  @click="parseLink(item1)">解析</el-button>
								<el-button type="text"  @click="gotoDetail(item1.purchaseDetailUrl)">跳转</el-button>
							</div>
						</el-input>
					</div>
					<div class="item">
						<el-select v-model="item1.purchaseDetailSku" placeholder="采购链接中的sku" style="width: 150px" clearable creatable filterable @change="skuChange(item1)" allow-create :ref="item1.ref">
							<el-option
								v-for="option in (item1.purchaseDetailUrl ? skuOptionsMap[item1.purchaseDetailUrl] ? skuOptionsMap[item1.purchaseDetailUrl] : [] : [])"
								:key="option"
								:label="option"
								:value="option"
							></el-option>
						</el-select>
					</div>
					<div class="item">
						<el-input v-model="item1.purchaseNum" placeholder="数量" style="width: 80px" type="number" />
					</div>
					<div class="item">
						<el-input v-model="item1.supplierName" placeholder="供应商" style="width: 200px" />
					</div>
					<div class="item">
						<el-input v-model="item1.price" placeholder="价格" style="width: 120px" />
					</div>
					<div class="item">
						<el-input v-model="item1.remark" placeholder="备注" style="width: 200px" />
					</div>
					<!-- <div class="item">
						<el-select v-model="item1.status" placeholder="是否自动采购" style="width: 120px" clearable disabled>
							<el-option label="自动采购" value="1"></el-option>
							<el-option label="取消自动采购" value="0"></el-option>
						</el-select>
					</div> -->
					<el-button type="danger" @click="delAddPurchase(item1, index1)">删除</el-button>
				</div>
			</div>
			<el-divider></el-divider>
			<div class="group-data-box">
				<div class="group-row" :class="orderSkuMap[addGroupSku] && item.data[0]['groupId'] == orderSkuMap[addGroupSku]['groupId'] ? 'use-block' : ''" v-for="item in groupData[addGroupSku]" :key="item.name">
					<div class="group-title">
						<div class="name">{{item.name}}</div>
						<div class="price">价格：{{item.price}}</div>
						<div>当前启用状态：
							<span :class="orderSkuMap[addGroupSku] && item.data[0]['groupId'] == orderSkuMap[addGroupSku]['groupId'] ? 'success-text' : 'error-text'">{{ orderSkuMap[addGroupSku] && item.data[0]['groupId'] == orderSkuMap[addGroupSku]['groupId'] ? '启用' : '停用' }}</span>
						</div>
						<el-button type="text" @click="changeOrderSku(item.data[0]['groupId'], orderSkuMap[addGroupSku] && item.data[0]['groupId'] == orderSkuMap[addGroupSku]['groupId'] ? '停用' : '启用')">{{ orderSkuMap[addGroupSku] && item.data[0]['groupId'] == orderSkuMap[addGroupSku]['groupId'] ? '停用' : '启用' }}</el-button>

						<!-- <div>当前自动填写采购需求状态：
							<span :class="item.data[0]['status'] == '1' ? 'success-text' : 'error-text'">{{ item.data[0]['status'] == '1' ? '开启' : '关闭' }}</span>
						</div>
						<el-button type="text" @click="changeGroupStatus(item.data[0])">{{ item.data[0]['status'] == '1' ? '关闭' : '开启' }}</el-button> -->
						<el-button type="danger" @click="delGroupData(item.data[0])">删除组数据</el-button>
					</div>
					<div class="purchase-content">
						<div class="purchase-row" v-for="(item1, index1) in item['data']" :key="index1">
							<div class="item">
								<el-input
									:disabled="UserInfo.uid == item1.uid ? false : true"
									placeholder="采购链接"
									v-model="item1.purchaseDetailUrl" style="width: 280px;" class="purchase-url-input">
									<div slot="suffix">
										<el-button  type="text"  @click="useExistLink(item1, addGroupSku)">引用链接</el-button>
										<el-button type="text"  @click="parseLink(item1)">解析</el-button>
										<el-button type="text"  @click="gotoDetail(item1.purchaseDetailUrl)">跳转</el-button>
									</div>
								</el-input>
							</div>
							<div class="item">
								<el-select :disabled="UserInfo.uid == item1.uid ? false : true" v-model="item1.purchaseDetailSku" placeholder="采购链接中的sku" style="width: 150px" clearable creatable filterable @change="skuChange(item1)" allow-create :ref="item1.ref">
									<el-option
										v-for="option in (item1.purchaseDetailUrl ? skuOptionsMap[item1.purchaseDetailUrl] ? skuOptionsMap[item1.purchaseDetailUrl] : [] : [])"
										:key="option"
										:label="option"
										:value="option"
									></el-option>
								</el-select>
							</div>
							<div class="item">
								<el-input :disabled="UserInfo.uid == item1.uid ? false : true" v-model="item1.purchaseNum" placeholder="数量" style="width: 80px" type="number" />
							</div>
							<div class="item">
								<el-input :disabled="UserInfo.uid == item1.uid ? false : true" v-model="item1.supplierName" placeholder="供应商" style="width: 200px" />
							</div>
							<div class="item">
								<el-input :disabled="UserInfo.uid == item1.uid ? false : true" v-model="item1.price" placeholder="价格" style="width: 120px">
									<div slot="suffix">
										￥
									</div>
								</el-input>
							</div>
							<div class="item">
								<el-input :disabled="UserInfo.uid == item1.uid ? false : true" v-model="item1.remark" placeholder="备注" style="width: 200px" />
							</div>
							<!-- <div class="item">
								<el-select v-model="item1.status" placeholder="是否自动采购" style="width: 120px" clearable disabled>
									<el-option label="自动采购" value="1"></el-option>
									<el-option label="取消自动采购" value="0"></el-option>
								</el-select>
							</div> -->
							<el-button type="success" v-if="UserInfo.uid == item1.uid" @click="submitAddPurchase(item1, index1, addGroupSku)">保存</el-button>
							<el-button type="danger" v-if="UserInfo.uid == item1.uid" @click="delPurchaseById(item1, index1, addGroupSku)">删除</el-button>
						</div>
					</div>
					<el-divider></el-divider>
				</div>
			</div>
		</el-dialog>
	</el-dialog>

	
</template>

<script>
import Sourceofsupply from './Source_ofsupply'
import { ajaxPost, Baseurl } from '../../../api/api/api'
import { copyText } from '@/utils/common.js'
export default {
	name: 'Orderpurchaseedit',
	components: {
		Sourceofsupply,
	},
	data() {
		return {
			sondata: '',
			arr: '',
			str: '',
			obj: '',
			id: '',
			activeName: 'first',
			inventoryList: [],
			inventoryList1: [],
			ReturninventoryList: [],
			ReturninventoryList1: [],
			ReturninventoryLists: [],
			ReturninventoryLists1: [],
			ReturninventoryList1s: [],
			btnloading: false,
			isLoading: false,
			isContent: '',
			innerVisibles: false,

			activities: [],
			innerVisible: false,
			AddinnerVisible: false,

			Hymall: false,
			ShopsString: '',
			GoodsMall: [],

			amazonOrderId: '',
			orderId: '',
			queryTrackSwitch: '',
			companyId: '',
			purchasePrice: '', //采购价
			purchaseModel: '', //采购详情
			rebatePrice: '', //返佣
			otherPrice: '', //退款费用
			actualRefund: '',
			purchaseTypeCode: '', //采购类型
			remark: '', //采购备注
			internalConveyNumber: '', //运单号码
			estimatedQuantity: 1,
			useQuantity: 1,
			logisticsCompany: '', //物流公司
			companyCode: '', //物流公司编码

			purchasePrice1: '', //采购价
			purchaseModel1: '', //采购详情
			rebatePrice1: '', //返佣
			otherPrice1: '', //退款费用
			actualRefund1: '', //实际退款
			purchaseTypeCode1: '', //采购类型
			remark1: '', //采购备注
			internalConveyNumber1: '', //运单号码
			estimatedQuantity1: 1,
			useQuantity1: 1,
			logisticsCompany1: '', //物流公司
			companyCode1: '', //物流公司编码

			purchaseNumber: '', //采购单据号
			selectType: '',
			id: '',
			type: '',
			type1: '',
			dialogTableVisible: false,
			system: '',
			typeid: '',
			dialogInnerVisible: false,
			productLinkList: [],
			productLinkList2: [],
			loading: '',
			showBtn: true,
			redShow: false,
			UseNumber: '',
			staticList: [],
			btndisabled: '',
			Logistics: [],
			Track17Logistics: [],
			isDisabled: '',
			isContens: '',
			tableLoading1: true,
			tableLoading2: true,
			searchString: '',
			activeName: 'first',
			inventorySkuList: [],

			currentPage: 1,
			pagesize: 20,
			size: 20,
			total: 0,

			currentPage1: 1,
			pagesize1: 20,
			size1: 20,
			total1: 0,

			tuiVisibles: false,
			tableLoading3: false,
			tuiTable: [],
			showTuiBool: false,

			tuiDialogList: [],
			searchString1: '',
			currentPage2: 1,
			pagesize2: 20,
			size2: 20,
			total2: 0,
			countryList: [],
			tuiIdLists: [],
			tuiBtnLoading: false,
			purchaseDemand: '',
			variantSku: '',
			sellerSku: '',
			countryMark: '',
			logisticsList: [],
			AddAllinnerVisible: false,
			fuhao: '',
			isAllLoading: false,
			purchaseAllList: [],
			teshu: '',
			baohanzong: 1,
			baohanzong1: 1,
			purchaseSkuData:{},
			skuOptionsMap: [],
			skuMoneyMap: {},
			groupIdMap:{},
			showNewGroupPurchaseDialog: false,
			groupPurchaseSkuData: [],
			addGroupSku: '',
			addGroupShopId: '',
			groupData: {},
			orderShopId: '',
			orderSkuMap: {},
		}
	},
	mounted() {},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.system = this.str.system
		this.getLogistics()
	},
	watch: {
		tuiVisibles(val) {
			if (!val) {
				this.tuiDialogList = []
				this.currentPage2 = 1
				this.size2 = 20
				this.pagesize2 = 20
				this.total2 = 0
				this.searchString1 = ''
				this.purchaseDemand = ''
				this.variantSku = ''
				this.sellerSku = ''
				this.countryMark = ''
			}
		},
		AddAllinnerVisible(val) {
			if (!val) {
				this.purchaseAllList = []
			}
		}
	},
	methods: {
		setAllPurchaseb() {
			if (!this.teshu) {
				this.$message.error("请先输入分割符！")
				return
			}
			let purchaseModels = this.purchaseModel1.split(this.teshu)
			this.purchaseAllList = []
			purchaseModels.map(item => {
				let obj = {
					companyId: this.str.company_id,
					purchaseRoleId: this.str.rid,
					amazonOrderId: this.amazonOrderId,
					orderId: this.orderId,
					purchaseFrom: '1',
					purchaseDemandId: this.id,
					internalConveyNumber: this.internalConveyNumber1,
					purchasePrice: this.purchasePrice1,
					rebatePrice: this.rebatePrice1,
					purchaseModel: item,
					logisticsCompany: this.logisticsCompany1,
					purchaseTypeCode: this.purchaseTypeCode1,
					remark: this.remark1,
					otherPrice: this.otherPrice1,
					actualRefund: this.actualRefund1,
					roleId: this.str.rid,
					companyCode: this.companyCode1
				}
				if (this.internalConveyNumber1) {
					this.$set(obj, 'estimatedQuantity', this.estimatedQuantity1)
					this.$set(obj, 'useQuantity', this.useQuantity1)
				} else {
					this.$set(obj, 'estimatedQuantity', 1)
					this.$set(obj, 'useQuantity', 1)
				}
				this.purchaseAllList.push(obj)
			})
		},
		myCopyText(text){
			copyText(text).then(() => {
				// 复制成功
				this.$message.success('复制成功');
			}).catch(() => {
				// 复制失败
				this.$message.error('复制失败');
			});
		},
		getLogistics() {
			const API = Baseurl + "purchaseController/selectItemList";
			const paramsData = {
				itemCode: "HYXUN0000006",
			};
			ajaxPost(API, paramsData).then(res => {
				const { code, data } = res.data;
				if (code === 200) {
					this.logisticsList = data;
				}
			});
		},
		gotoDetail(url){
			window.open(url);
		},
		submitTui() {
			if (!this.tuiIdLists.length) {
				this.$message.error("至少选择一条数据才能提交！")
				return
			}
			this.tuiBtnLoading = true
			ajaxPost(
        Baseurl + 'codReturnController/matchCodReturn',
				{idList: this.tuiIdLists, newOrderId: this.sondata.amazonOrderId, rid: this.str.rid}
      ).then((res) => {
        if (res.data.code === 200) {
          this.$message.success("提交成功")
					this.tuiVisibles = false
					this.getTuiTable()
        } else {
					this.$message.error(res.data.message)
				}
				this.tuiBtnLoading = false
      })
		},
		getCountry() {
      ajaxPost(
        Baseurl + 'logisticsConfigurationController/selectLogisticsCountryList'
      ).then((res) => {
        if (res.data.code === 200) {
          this.countryList = res.data.data
        }
      })
    },
		handleResetTable() {
			this.currentPage2 = 1
			this.searchString1 = ''
			this.purchaseDemand = ''
			this.countryMark = ''
			this.variantSku = ''
			this.sellerSku = ''
			this.handleTuiTable()
		},
		seachHandleTuiTable() {
			this.currentPage2 = 1
			this.handleTuiTable()
		},
		randomString(length = 16) {
			const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
			let result = '';
			for (let i = 0; i < length; i++) {
				result += chars.charAt(Math.floor(Math.random() * chars.length));
			}
			return result;
		},
		isSamePerson(sku){
			if(this.purchaseSkuData[sku]){
				const arr = this.purchaseSkuData[sku];
				const firstCreateRole = arr[0]['uid'];
				return this.UserInfo.uid == firstCreateRole;
			}
			return true;
		},
		addGroupPurchase(){
			this.groupPurchaseSkuData.unshift({
				"purchaseDetailUrl": "",
				"purchaseDetailSku": "",
				"purchaseNum": "",
				"remark": "",
				"status": "0",
				ref: this.randomString(16),
				checked: true,
			})
		},
		// 添加组数据
		async saveGroupPurchase(){
			if(this.groupPurchaseSkuData.length == 0){
				this.$message.error("请添加数据！");
				return
			}
			const role = JSON.parse(localStorage.getItem('role'));
			const groupId = this.generateUUID();
			const arr = [];
			for(let i = 0; i < this.groupPurchaseSkuData.length; i++){
				const row = this.groupPurchaseSkuData[i];
				if(row.checked){
					const item = {
						...row,
						groupId,
						createRole: '采购',
						isUse: '0',
						shopId: this.orderShopId,
						sku: this.addGroupSku,
						uid: role.uid,
					}
					arr.push(item);
				}
			}
			if(arr.length == 0){
				this.$message.error("请添加数据！");
				return
			}
			const api = Baseurl + 'purchaseSkuController/insertBatch';
			const res = await ajaxPost(api, arr)
			if (res.data.code == 200) {
				this.$message.success('保存成功');
				this.getPurchaseSkuData();
				this.groupPurchaseSkuData = []; //清空添加了的数据
			} else {
				this.$message.error(res.data.msg);
			}
		},
		// 修改组数据
		async submitAddPurchase(item, index, sku){
			let api = '';
			// 修改
			api = Baseurl + 'purchaseSkuController/update';
			const res = await ajaxPost(api, item)
			if (res.data.code == 200) {
				this.$message.success('保存成功');
				this.getPurchaseSkuData();
			} else {
				this.$message.error(res.data.msg);
			}
		},
		// 改变启用状态
		async changeGroupIsUse(item){
			const api = Baseurl + 'purchaseSkuController/changeIsUse';
			const res = await ajaxPost(api, item)
			if (res.data.code == 200) {
				this.$message.success('保存成功');
				this.getPurchaseSkuData();
			} else {
				this.$message.error(res.data.msg);
			}
		},
		// 改变是否自动采购
		async changeGroupStatus(item){
			// 先查看这条数据的is_use是不是1，如果是1才能开启自动采购
			if(item['isUse'] == '1'){
				const api = Baseurl + 'purchaseSkuController/changeStatus';
				const res = await ajaxPost(api, item)
				if (res.data.code == 200) {
					this.$message.success('保存成功');
					this.getPurchaseSkuData();
				} else {
					this.$message.error(res.data.msg);
				}
			}else{
				this.$message.error("需要先启用当前组，才能开启自动采购")
			}
		},
		// 删除组数据
		delAddPurchase(item, index, sku){
			this.groupPurchaseSkuData.splice(index, 1);
		},
		skuChange(item){
			if(this.skuMoneyMap[item.purchaseDetailUrl] && this.skuMoneyMap[item.purchaseDetailUrl][item.purchaseDetailSku]){
				const money = this.skuMoneyMap[item.purchaseDetailUrl][item.purchaseDetailSku];
				this.$set(item, 'price', money);
			}
		},
		async submitPurchase(item, index, sku, isGetData){
			const role = JSON.parse(localStorage.getItem('role'));
			let api = '';
			if(item.id){
				// 修改
				api = Baseurl + 'purchaseSkuController/update';
			}else{
				// 新建
				api = Baseurl + 'purchaseSkuController/insert';
				item['groupId'] = this.groupIdMap[sku];
				item['createRole'] = '采购';
				item['isUse'] = '1';
				item["shopId"] = this.orderShopId;
				item['sku'] = sku;
				item['uid'] = role.uid;
			}
			const res = await ajaxPost(api, item)
			if (res.data.code == 200) {
				if(isGetData){
					this.$message.success('保存成功');
					this.getPurchaseSkuData();
				}else{
					
				}
			} else {
				this.$message.error(res.data.msg);
			}
		},
		delPurchase(item, index, sku){
			this.$confirm('确认删除此条数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.$nextTick(()=>{
					if(item.id){
						var obj = { id: item.id}
						ajaxPost(
							Baseurl + 'purchaseSkuController/deletePurchaseById',
							obj
						).then(async (res) => {
							if (res.data.code == 200) {
								this.$message({
									type: 'success',
									message: '删除成功!',
								})
								const orderSkuData = this.orderSkuMap[sku] || null;
								if(orderSkuData && orderSkuData['groupId'] == item.groupId){
									// 根据item.groupId，判断当前组下是否还有数据，如果没有了，则删除该组
									const groupId = item.groupId;
									const res2 = await ajaxPost(Baseurl + 'purchaseSkuController/getPurchaseByGroupId',
										{ groupId }
									);
									if(res2.data.code == 200){
										const data2 = res2.data.data;
										if(data2 == 0){ //说明这一组下面的数据都被删除了，需要删除关联表
											const api2 = Baseurl + 'purchaseSkuController/delOrderSkuStatusById';
											const res43 = await ajaxPost(api2, {id: orderSkuData['id']});
											await this.getOrderSkuMap();
										}
									}
								}
								this.getPurchaseSkuData();
							} else {
								this.$message.error('删除失败')
							}
						})
					}else{
						// 手动创建的还没有保存过的，直接删除
						const arr = this.purchaseSkuData[sku];
						arr.splice(index, 1);
						this.$set(this.purchaseSkuData, sku, arr);
					}
				})
			}).catch((e) => {
				this.$message({
					type: 'info',
					message: '已取消删除',
				})
			})
		},
		delPurchaseById(item, index, sku){
			this.$confirm('确认删除此条数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.$nextTick(()=>{
					var obj = { id: item.id}
					ajaxPost(
						Baseurl + 'purchaseSkuController/deletePurchaseById',
						obj
					).then(async (res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							const orderSkuData = this.orderSkuMap[sku] || null;
							if(orderSkuData && orderSkuData['groupId'] == item.groupId){
								// 根据item.groupId，判断当前组下是否还有数据，如果没有了，则删除该组
								const groupId = item.groupId;
								const res2 = await ajaxPost(Baseurl + 'purchaseSkuController/getPurchaseByGroupId',
									{ groupId }
								);
								if(res2.data.code == 200){
									const data2 = res2.data.data;
									if(data2 == 0){ //说明这一组下面的数据都被删除了，需要删除关联表
										const api2 = Baseurl + 'purchaseSkuController/delOrderSkuStatusById';
										const res43 = await ajaxPost(api2, {id: orderSkuData['id']});
										await this.getOrderSkuMap();
									}
								}
							}
							this.getPurchaseSkuData();
						} else {
							this.$message.error('删除失败')
						}
					})
				})
			}).catch((e) => {
				this.$message({
					type: 'info',
					message: '已取消删除',
				})
			})
		},
		addNewGroupPurchase(sku){
			this.addGroupSku = sku;
			this.groupPurchaseSkuData = [];
			this.showNewGroupPurchaseDialog = true;
		},
		delGroupData(item){
			this.$confirm('确认删除此组数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				this.$nextTick(()=>{
					var obj = { groupId: item.groupId}
					ajaxPost(
						Baseurl + 'purchaseSkuController/deletePurchaseByGroupId',
						obj
					).then(async (res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							const sku = item.sku;
							const orderSkuData = this.orderSkuMap[sku] || null;
							if(orderSkuData && orderSkuData['groupId'] == item.groupId){
								const api2 = Baseurl + 'purchaseSkuController/delOrderSkuStatusById';
								const res43 = await ajaxPost(api2, {id: orderSkuData['id']});
								await this.getOrderSkuMap();
							}
							this.getPurchaseSkuData();
						} else {
							this.$message.error('删除失败')
						}
					})
				})
			}).catch((e) => {
				this.$message({
					type: 'info',
					message: '已取消删除',
				})
			})
		},
		// 调用领星解析url
		parseLink(item){
			const url = item.purchaseDetailUrl;
			ajaxPost(
				"https://hx1.hyxun.top/api/parseLink",
				{ url: url }
			).then((res) => {
				if(res.status == 200){
					if(res.data.data.code == 1){
						const result = res.data.data.data[0];
						const arr = result['sku_infos'] || [];
						const options = [];
						const obj = {};
						for(let i = 0; i < arr.length; i++){
							const item = arr[i];
							if(item['amount_on_sale'] && item['amount_on_sale'] > 0){
								let text = [];
								for(let j = 0; j < item['attributes'].length; j++){
									const attr = item['attributes'][j];
									text.push(attr['attribute_value']);
								}
								options.push(text.join(' '));
								obj[text.join(' ')] = item['price'] ? item['price'] : '0';
							}
						}
						this.$set(this.skuMoneyMap, url, obj);
						this.$set(this.skuOptionsMap, url, options);
						const supplierName = result['cross_basic_info']['supplierName'];
						const supplierLink = result['cross_basic_info']['shopUrl'];
						this.$set(item, 'supplierName', supplierName);
						this.$set(item, 'supplierLink', supplierLink);
						this.$refs[item.ref] && this.$refs[item.ref][0].toggleMenu();
						this.$message.success("解析完成！")
						// this.$set(item, 'skuOptions', options)
					}else {
						if(res.data.data.code == -999){
							this.$message.error('1688解析失效,请联系技术人员解决')
						}else{
							this.$message.error(res.data.data.msg)
						}
					}
				}else{
					this.$message.error('解析失败：' + res.data.message)
				}
			})
		},
		async savePurchaseSkuData(){
			const allPro = [];
			for(let k in this.purchaseSkuData){
				const skuArr = this.purchaseSkuData[k];
				for(let i = 0; i < skuArr.length; i++){
					const item = skuArr[i];
					if(item.purchaseDetailUrl || item.purchaseDetailSku || item.purchaseNum){
						if((item.purchaseNum + '').trim() && isNaN(Number(item.purchaseNum))){
							this.$message.error('采购数量请输入数字');
							return;
						}
						const pro1 = this.submitPurchase(item, 0, k, false);
						allPro.push(pro1);
					}
				}
			}
			Promise.all(allPro).then((res)=>{
				this.$message.success('保存成功');
				this.getPurchaseSkuData();
			})
		},
		async getPurchaseSkuData(){
			const params1 = {
				id: this.sondata.shopId
			}
			const res1 = await ajaxPost(Baseurl + 'seller/selectCountrySellerById', params1);
			if(res1.data.code == 200){
				this.orderShopId = res1.data.data.sellerInfoId; // 这个订单的店铺id
			}
			const arr = [];
			const obj2 = {};
			for(let i = 0; i < this.sondata.productInfos.length; i++){
				arr.push(this.sondata.productInfos[i].sku);
				obj2[this.sondata.productInfos[i].sku] = [];
			}
			
			const res11 = await ajaxPost(
				Baseurl + 'systemProduct/selectSystemSkuBySkuLists',
				{skus: arr.join(",")}
			)
			const allRes = [];
			let skuMap = {};
			if(res11.data.code == 200){ //这里能查到，说明某一个在sku管理能查到数据
				skuMap = res11.data.data || {}; //根据这些去查找运营填写的数据
			}
			for(let k in obj2){
				if(!skuMap[k] || !skuMap[k].length || skuMap[k].length == 0){ //查不到数据
					const params = {
						sku: [k],
						shopId: this.orderShopId,
					}
					const res22 = await ajaxPost(Baseurl + 'purchaseSkuController/getByShopAndSkus', params);
					if(res22.data.code == 200){
						allRes.push(...res22.data.data);
					}
				}else{
					const arr1 = skuMap[k];
					const allPro = [];
					for(let i = 0; i < arr1.length; i++){
						const params = {
							sku: [arr1[i].alias],
							shopId: arr1[i].shopId,
						}
						allPro.push(ajaxPost(Baseurl + 'purchaseSkuController/getByShopAndSkus', params).then((res2)=>{
							if(res2.data.code == 200){
								const res3 = res2.data.data;
								for(let j = 0; j < res3.length; j++){
									res3[j]['parentSku'] = k;
									allRes.push(res3[j]);
								}
							}
						}));
					}
					await Promise.all(allPro);
				}
			}
			const obj = {};
			const groupData = {}; //组数据，{sku：{组id：{data: [每一项数据...], name: 组名，price：价钱}, 组id：[], } }
			const result = allRes;
			let index1 = 1;
			for(let i = 0; i < result.length; i++){
				const item = result[i];
				let sku = item.sku;
				if(item.parentSku){
					sku = item.parentSku;
				}
				item['ref'] = this.randomString(16);
				if(!groupData[sku]){
					groupData[sku] = {};
				}

				
				if(!groupData[sku][item.groupId]){
					groupData[sku][item.groupId] = {
						price: 0,
						name: '组' + index1,
						data: [],
					};
					index1 ++;
				}
				groupData[sku][item.groupId]['data'].push(item);
				groupData[sku][item.groupId]['price'] += (item['price'] ? +item['price'] : 0);
			}
			for(let k in groupData){
				let minGroupId = null;
				let minPrice = 999999999999999;
				for(let groupId in groupData[k]){
					if(minPrice > groupData[k][groupId]['price']){
						minPrice = groupData[k][groupId]['price'];
						minGroupId = groupId;
					}
				}
				if(this.orderSkuMap[k]){
					minGroupId = this.orderSkuMap[k]['groupId'];
				}
				obj[k] = groupData[k][minGroupId]['data'];

				const groups = groupData[k];
				// 转成数组并排序
				const sortedGroups = Object.entries(groups)
					.sort((a, b) => a[1].price - b[1].price); // 按价格降序
				
				// 可选：生成新的结构或者数组
				groupData[k] = Object.fromEntries(sortedGroups);
			}
			const groupIdMap = {};
			for(let k in obj2){
				if(obj[k] && obj[k].length > 0){
					obj2[k] = obj[k];
					groupIdMap[k] = obj[k][0]['groupId'];
				}else{
					obj2[k] = [
						{
							"purchaseDetailUrl": "",
							"purchaseDetailSku": "",
							"purchaseNum": "",
							"remark": "",
							"status": "1",
							ref: this.randomString(16)
						}
					];
					groupIdMap[k] = this.generateUUID();
				}
			}

			// 排序，保持和采购需求一致
			let purchaseDemand = this.sondata.purchaseDemand || '';
			if(purchaseDemand.includes("(自动)")){
				purchaseDemand = purchaseDemand.replace("(自动)", "");
				const regex = /([\u4e00-\u9fff\w]+)\*\d+/g;
				const matches = [...purchaseDemand.matchAll(regex)].map(m => m[1]);
				const orderItems = this.sondata.productInfos;
				orderItems.sort((a,b)=>{
					let aIndex = Infinity;
					let bIndex = Infinity;

					if (obj[a.sku] && obj[a.sku][0] && obj[a.sku][0]['purchaseDetailSku'] !== undefined) {
						aIndex = matches.indexOf(obj[a.sku][0]['purchaseDetailSku']);
					}

					if (obj[b.sku] && obj[b.sku][0] && obj[b.sku][0]['purchaseDetailSku'] !== undefined) {
						bIndex = matches.indexOf(obj[b.sku][0]['purchaseDetailSku']);
					}

					return aIndex - bIndex;
				})
				this.$set(this.sondata, 'productInfos', orderItems);
			}
			this.purchaseSkuData = obj2;
			this.groupIdMap = groupIdMap;
			this.groupData = groupData;
		},
		async getOrderSkuMap(){
			const arr = [];
			for(let i = 0; i < this.sondata.productInfos.length; i++){
				arr.push(this.sondata.productInfos[i].sku);
			}
			const api = Baseurl + 'purchaseSkuController/getOrderSkuStatus';
			const params = {
				amazonOrderId: this.sondata.amazonOrderId,
				skus: arr,
			}
			const res = await ajaxPost(api, params)
			if(res.data.code == 200){
				const res1 = res.data.data;
				this.orderSkuMap = res1;
			}
		},
		changeOrderSku(groupId, text){
			const orderSkuData = this.orderSkuMap[this.addGroupSku] || null;
			if(text == '停用' && orderSkuData){
				let api = '';
				const params = {};
				params['id'] = orderSkuData.id;
				api = Baseurl + 'purchaseSkuController/delOrderSkuStatusById';
				ajaxPost(api, params).then(async (res)=>{
					if(res.data.code == 200){
						this.$message.success('操作成功');
						await this.getOrderSkuMap();
						this.getPurchaseSkuData();
					}else{
						this.$message.error(res.data.msg);
					}
				})
			}else{
				
				const params = {
					sku: this.addGroupSku,
					groupId,
					amazonOrderId: this.sondata.amazonOrderId,
				}
				let api = '';
				if(orderSkuData){
					params['id'] = orderSkuData.id;
					api = Baseurl + 'purchaseSkuController/updateOrderSkuStatus';
				}else{
					api = Baseurl + 'purchaseSkuController/insertOrderSkuStatus';
				}
				ajaxPost(api, params).then(async (res)=>{
					if(res.data.code == 200){
						this.$message.success('操作成功');
						await this.getOrderSkuMap();
						this.getPurchaseSkuData();
					}else{
						this.$message.error(res.data.msg);
					}
				})
			}
			
		},
		generateUUID() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0,
					v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},
		// 采购链接同首行
		setAllPurchaseUrl(){
			let index = 0;
			let url = '';
			for(let k in this.purchaseSkuData){
				if(index == 0){
					const firstSkuArr = this.purchaseSkuData[k];
					if(firstSkuArr.length > 0){
						url = firstSkuArr[0].purchaseDetailUrl;
					}
				}else{
					const skuArr = this.purchaseSkuData[k];
					if(skuArr.length > 0){
						for(let i = 0; i < skuArr.length; i++){
							skuArr[i].purchaseDetailUrl = url;
						}
						this.$set(this.purchaseSkuData, k, skuArr);
					}
				}
				index++;
			}
		},
		// 添加采购信息
		addPurchase(sku){
			if(this.purchaseSkuData[sku]){
				const arr = this.purchaseSkuData[sku];
				arr.push({
					"purchaseDetailUrl": "",
					"purchaseDetailSku": "",
					"purchaseNum": "",
					"remark": "",
					"status": "1",
					ref: this.randomString(16)
				});
				this.$set(this.purchaseSkuData, sku, arr);
			}else{
				this.$set(this.purchaseSkuData, sku, [
					{
						"purchaseDetailUrl": "",
						"purchaseDetailSku": "",
						"purchaseNum": "",
						"remark": "",
						"status": "1",
						ref: this.randomString(16)
					}
				]);
			}
		},
		// 使用已存在的链接
		useExistLink(item, sku){
			ajaxPost(Baseurl + 'productController/getProductSourceLink', {
				sku: sku,
				countryMark: '',
			}).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					const d = data.filter(item => item);
					if(d.length == 1){
						this.$set(item, 'purchaseDetailUrl', d[0]);
					}else{
						this.$message.info('该SKU存在多个货源链接，请手动填写！')
						return
					}
				}else{
					this.$message.error(res.data.message);
				}
			})
		},
		handleTuiTable() {
			if (this.tuiVisibles == false) {
				this.purchaseDemand = this.sondata.purchaseDemand.split('COD ')[1] ? this.sondata.purchaseDemand.split('COD ')[1] : this.sondata.purchaseDemand
				this.countryMark = this.sondata.countryMark
			}
			this.tuiVisibles = true
			const data = {
				rid: this.str.rid,
				searchStr: this.searchString1,
				amazonOrderId: this.sondata.amazonOrderId,
				purchaseModel: this.purchaseDemand,
				variantSku: this.variantSku,
				sellerSku: this.sellerSku,
				countryMark: this.countryMark,
				page: this.currentPage2,
				size: this.size2
			}
			this.tableLoading3 = true
			ajaxPost(
				Baseurl + 'codReturnController/unMatchedPageInfo',
				data
			).then((res) => {
				if (res.data.code == 200) {
					// res.data.data.list.map(element => {
					// 	if (element.orderInfo.purchaseDemands) {
					// 		element.orderInfo.purchaseDemands.map(item => {
					// 			if (item.purchaseDemand) {
					// 				item.purchaseDemand = item.purchaseDemand.split('COD ')[1]
					// 			}
					// 			if (item.purchaseItems) {
					// 				item.purchaseItems.map(ele => {
					// 					if (ele.purchaseModel) {
					// 						ele.purchaseModel = ele.purchaseModel.split('COD ')[1]
					// 					}
					// 				})
					// 			}
					// 		})
					// 	}
					// })
					res.data.data.list.map(item => {
						let obj = this.logisticsList.filter(x => x.itemTypeId == item.channelType)
						this.$set(item, 'channelName', obj[0].itemTypeName)
					})
					this.tuiDialogList = res.data.data.list
					this.total2 = res.data.data.total
				}
				this.tableLoading3 = false
			})
		},
		handleTui(id) {
			this.$confirm('是否确认回退?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				ajaxPost(
					Baseurl + 'codReturnController/backCodReturn',
					{id}
				).then((res) => {
					if (res.data.code == 200) {
						this.$message.success("回退成功")
						this.getTuiTable()
					} else {
						this.$message.error(res.data.message)
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消回退'
				});          
			})
		},
		getTuiTable() {
			const data = {
				newOrderId: this.sondata.amazonOrderId,
			}
			ajaxPost(
				Baseurl + 'codReturnController/getMatchedCodReturnList',
				data
			).then((res) => {
				this.tuiTable = res.data.data
			})
		},
		typeCode() {
			var itemCode = {
				itemCode: 'HYXUN0000001',
			}
			ajaxPost(
				Baseurl + 'purchaseController/selectItemList',
				itemCode
			).then((res) => {
				this.selectType = res.data.data
			})
		},
		getRole() {
			ajaxPost(
				Baseurl + 'companyController/getCompanyIdsApplyOrderExport'
			).then((res) => {
				this.showTuiBool = res.data.data.includes(this.str.company.id)
			})
		},
		async init(e) {
			this.UserInfo = JSON.parse(localStorage.getItem('role'))
			var str = JSON.parse(localStorage.getItem('role'))
			this.system = str.system
			this.dialogTableVisible = true
			this.sondata = e
			this.id = this.sondata.id
			// console.log(this.sondata);
			this.amazonOrderId = this.sondata.amazonOrderId
			this.orderId = this.sondata.orderId
			this.queryTrackSwitch = this.sondata.queryTrackSwitch
			this.Editrendering()
			this.Thelog()
			this.inventoryController()
			this.LogisticsAjax()
			this.Track17LogisticsAjax()
			this.getTuiTable()
			this.getRole()
			this.getCountry()
			this.getPurchaseSkuData();
			await this.getOrderSkuMap();
			// this.matchingAjax()
			if (this.sondata.buttonStatus == 0) {
				this.btndisabled = true
			} else if (this.sondata.buttonStatus == 1) {
				this.btndisabled = false
			}
		},
		Editor(itemValue) {
			this.typeCode()
			this.innerVisible = true
			this.typeid = itemValue.id
			// console.log(itemValue);
			if (itemValue.checkResult == 4) {
				this.isDisabled = false
				this.isContent = '请填写物流公司/运单号码'
				this.isContens =
					'完整描述海逊仓库核对的细节，海逊仓库将按照此详情核对'
			} else {
				this.isDisabled = true
				this.isContent =
					'该采购单已经入库，国内单号和物流公司不能修改！'
				this.isContens = '已经入库，不能修改！'
			}
			this.purchaseNumber = itemValue.purchaseNumber
			this.purchasePrice = itemValue.purchasePrice
			this.purchaseModel = itemValue.purchaseModel
			this.rebatePrice = itemValue.rebatePrice
			this.otherPrice = itemValue.otherPrice
			this.actualRefund = itemValue.actualRefund
			this.purchaseTypeCode = itemValue.purchaseTypeCode
			this.remark = itemValue.remark
			this.internalConveyNumber = itemValue.internalConveyNumber
			this.logisticsCompany = itemValue.logisticsCompany
			this.companyCode1 = itemValue.companyCode
			this.companyCode = itemValue.companyCode
		},
		Thelog() {
			ajaxPost(Baseurl + 'logisticsController/getOrderOperateLog', {
				orderId: this.sondata.orderId,
			}).then((res) => {
				if (res.data.code == 200) {
					this.activities = res.data.data
				}
			})
		},
		shopChange(value) {
			this.purchaseTypeCode = value
		},
		shopChange1(value) {
			this.purchaseTypeCode1 = value
		},
		AddPurchaselist() {
			this.typeCode()
			this.purchaseModel1 = this.sondata.purchaseDemand
			this.AddinnerVisible = true
		},
		AddAllPurchaselist() {
			this.typeCode()
			this.purchaseModel1 = this.sondata.purchaseDemand
			this.AddAllinnerVisible = true
		},
		Editrendering() {
			var orderid = {
				amazonOrderId: this.amazonOrderId,
				id: this.id,
			}
			ajaxPost(
				Baseurl +
					'purchaseController/selectPurchasesByPurchaseDemandId',
				orderid
			).then((res) => {
				var list = res.data.data
				for (var i = 0; i < list.length; i++) {
					list[i].system = this.system
				}

				this.obj = list
			})
		},
		Purchaseb() {
			// if(this.internalConveyNumber == ""){
			if (
				!this.internalConveyNumber &&
				this.logisticsCompany
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else if (
				this.internalConveyNumber &&
				!this.logisticsCompany
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else if (Number(this.actualRefund) < Number(this.otherPrice)) {
				this.$message.error(' 实际退款不能小于退款费用/运营退款')
			} else {
				this.SaveAjax()
			}

			// }else{
			//     var obj = {
			//         num: this.internalConveyNumber
			//     };
			//     ajaxPost(Baseurl + "conveyNumberQueryController/autoNum", obj).then(res => {
			//         // console.log(res.data);
			//         if(res.data.code == 200){
			//             this.SaveAjax()
			//         }else{
			//             this.$message.error(res.data.data)
			//         }
			//     });
			// }
		},
		SaveAjax() {
			var addproduct = {
				companyId: this.str.company_id,
				purchaseRoleId: this.str.rid,
				amazonOrderId: this.amazonOrderId,
				purchaseFrom: '1',
				id: this.typeid,
				internalConveyNumber: this.internalConveyNumber,
				purchasePrice: this.purchasePrice,
				rebatePrice: this.rebatePrice,
				purchaseModel: this.purchaseModel,
				logisticsCompany: this.logisticsCompany,
				purchaseTypeCode: this.purchaseTypeCode,
				remark: this.remark,
				otherPrice: this.otherPrice,
				actualRefund: this.actualRefund,
				queryTrackSwitch: this.sondata.queryTrackSwitch,
				companyCode: this.companyCode,
				roleId: this.str.rid,
			}
			if (this.internalConveyNumber) {
				let obj = {
					internalConveyNumber: this.internalConveyNumber,
					estimatedQuantity: this.estimatedQuantity,
					useQuantity: this.useQuantity
				}
				this.$set(addproduct, 'logisticsInformation', obj)
			}
			ajaxPost(
				Baseurl + '/purchaseController/updatePurchase',
				addproduct
			).then((res) => {
				if (res.data.code == 200) {
					this.$message({ message: '保存成功', type: 'success' })
					this.innerVisible = false
					// this.SavesubscribeAjax()  //快递100订阅
					this.Track17RegisterAjax(this.queryTrackSwitch)	//17track注册物流单号
					this.Editrendering()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		SavesubscribeAjax() {
			var obj = {
				companyId: this.sondata.companyId,
				number: this.internalConveyNumber,
				company: this.companyCode,
			}
			ajaxPost(
				Baseurl + 'conveyNumberQueryController/subscribe',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					// console.log(res.data);
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		Track17RegisterAjax(queryTrackSwitch) {
			if(queryTrackSwitch == 1){
				var obj = [{
					number: this.internalConveyNumber,
					carrier: this.companyCode,
				}]
				ajaxPost(
					Baseurl + 'track17Controller/register',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						console.log(res.data);
					} else {
						this.$message.error(res.data.data)
					}
				})
			}
			
		},
		Purchasedel(itemValue) {
			this.$confirm('删除此条单据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var TheId = { id: itemValue }
					ajaxPost(
						Baseurl + 'purchaseController/deletePurchaseById',
						TheId
					).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							this.Editrendering()
							this.$emit('refresh')
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		AddPurchaseb() {
			// if(this.internalConveyNumber1 == ""){
			if (
				!this.internalConveyNumber1 &&
				this.logisticsCompany1
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else if (
				this.internalConveyNumber1 &&
				!this.logisticsCompany1
			) {
				this.$message.error('物流公司和运单号码必须同时填写')
			} else if (Number(this.actualRefund1) < Number(this.otherPrice1)) {
				this.$message.error('实际退款不能小于退款费用/运营退款')
			} else {
				this.AddAjax()
			}
			// }else{
			//     var obj = {
			//         num: this.internalConveyNumber1
			//     };
			//     ajaxPost(Baseurl + "conveyNumberQueryController/autoNum", obj).then(res => {
			//         console.log(res.data);
			//         if(res.data.code == 200){
			//             this.AddAjax()
			//         }else{
			//             this.$message.error(res.data.data)
			//         }
			//     });
			// }
		},
		AddAjax() {
			this.isLoading = true
			var addproduct = {
				companyId: this.str.company_id,
				purchaseRoleId: this.str.rid,
				amazonOrderId: this.amazonOrderId,
				orderId: this.orderId,
				purchaseFrom: '1',
				purchaseDemandId: this.id,
				internalConveyNumber: this.internalConveyNumber1,
				purchasePrice: this.purchasePrice1,
				rebatePrice: this.rebatePrice1,
				purchaseModel: this.purchaseModel1,
				logisticsCompany: this.logisticsCompany1,
				purchaseTypeCode: this.purchaseTypeCode1,
				remark: this.remark1,
				otherPrice: this.otherPrice1,
				actualRefund: this.actualRefund1,
				roleId: this.str.rid,
				companyCode: this.companyCode1,
			}
			if (this.internalConveyNumber1) {
				let obj = {
					internalConveyNumber: this.internalConveyNumber1,
					estimatedQuantity: this.estimatedQuantity1,
					useQuantity: this.useQuantity1
				}
				this.$set(addproduct, 'logisticsInformation', obj)
			}
			ajaxPost(
				Baseurl + 'purchaseController/insertPurchase',
				addproduct
			).then((res) => {
				if (res.data.code == 200) {
					this.isLoading = false
					this.$message({ message: '保存成功', type: 'success' })
					// console.log(res.data.data);
					// this.subscribeAjax()  //快递100订阅
					this.Track17RegisterAjax1(this.queryTrackSwitch)  //17track
					this.AddinnerVisible = false
					this.Editrendering()
					this.$emit('refresh')
				} else {
					this.$message.error(res.data.data)
					this.isLoading = false
				}
			})
			var arr = {
				id: this.id,
				status: '已采购',
			}
			ajaxPost(
				Baseurl + 'purchaseDemandController/updatePurchaseDemandStatus',
				arr
			).then((res) => {
				// console.log(res.data);
			})
		},
		AddAllPurchaseb() {
			let bool1 = false
			let bool2 = false
			let bool3 = false
			this.purchaseAllList.map(item => {
				if (!item.internalConveyNumber && item.logisticsCompany) {
					bool1 = true
				}
				if (item.internalConveyNumber && !item.logisticsCompany) {
					bool2 = true
				}
				if (Number(item.actualRefund) < Number(item.otherPrice)) {
					bool3 = true
				}
				if (item.internalConveyNumber) {
					let obj = {
						internalConveyNumber: item.internalConveyNumber,
						estimatedQuantity: item.estimatedQuantity,
						useQuantity: item.useQuantity
					}
					this.$set(item, 'logisticsInformation', obj)
				} else {
					delete item.estimatedQuantity
					delete item.useQuantity
				}
			})
			if (bool1) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			}
			if (bool2) {
				this.$message.error('物流公司和运单号码必须同时填写')
				return
			}
			if (bool3) {
				this.$message.error('实际退款不能小于退款费用/运营退款')
				return
			}
			this.isAllLoading = true
			ajaxPost(
				Baseurl + 'purchaseController/batchInsertPurchase',
				this.purchaseAllList
			).then((res) => {
				if (res.data.code == 200) {
					this.isAllLoading = false
					this.$message({ message: '保存成功', type: 'success' })
					// console.log(res.data.data);
					// this.subscribeAjax()  //快递100订阅
					this.Track17RegisterAjax1(this.queryTrackSwitch)  //17track订阅
					this.AddAllinnerVisible = false
					this.Editrendering()
					this.$emit('refresh')
				} else {
					this.$message.error(res.data.data)
					this.isAllLoading = false
				}
			})
		},
		subscribeAjax() {
			var obj = {
				companyId: this.sondata.companyId,
				number: this.internalConveyNumber1,
				company: this.companyCode1,
			}
			ajaxPost(
				Baseurl + 'conveyNumberQueryController/subscribe',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					// console.log(res.data);
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		Track17RegisterAjax1(queryTrackSwitch){
			if(queryTrackSwitch == 1){
				var obj = [{
					number: this.internalConveyNumber1,
					carrier: this.companyCode1,
				}]
				ajaxPost(
					Baseurl + 'track17Controller/register',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						console.log(res.data);
					} else {
						this.$message.error(res.data.data)
					}
				})
			}
		},

		async visibleProductLink(sku) {
			const API = Baseurl + 'productController/getProductSourceLink'
			const paramsData = {
				// sku: this.sondata.productInfos[0].sku,
				sku,
				countryMark: '',
			}
			const {
				data: { code, data },
			} = await ajaxPost(API, paramsData)
			if (code === 200) {
				this.dialogInnerVisible = true
				this.productLinkList2 = data
				this.productLinkList = this.productLinkList2.map(
					(item, index) => ({ id: index, value: item })
				)
			}
		},
		edit_blue_point() {
			if (this.productLinkList.length === 5) return
			this.productLinkList.push({
				id: this.productLinkList.length + 1,
				value: '',
			})
		},
		edit_blue_del(index) {
			this.productLinkList.splice(index, 1)
		},
		async addProductLink() {
			if (!this.productLinkList.length) return
			this.loading = 'dialogInnerVisible'
			const API = Baseurl + 'productController/updateProductSourceLink'
			const sourceLinks = this.productLinkList.map((item) => item.value)
			const paramsData = {
				sku: this.sondata.productInfos[0].sku,
				areaName: '',
				sourceLinks,
			}
			const {
				data: { code, data },
			} = await ajaxPost(API, paramsData)
			this.loading = ''
			if (code === 200) {
				this.dialogInnerVisible = false
				this.$message.success('操作成功')
			} else {
				this.$message.error('操作失败')
			}
		},
		openLink(path) {
			if (!path) return
			window.open(path)
		},
		matching() {
			this.innerVisibles = true
			this.searchString = ''
			this.matchingAjax()
			this.matchingAjax1()
		},
		matchingAjaxSearch() {
			this.currentPage = 1
			this.matchingAjax()
		},
		matchingAjax() {
			this.tableLoading1 = true
			var obj = {
				roleId: this.str.rid,
				companyId: this.str.company_id,
				searchString: this.searchString,
				page: this.currentPage,
				size: this.size,
			}
			ajaxPost(Baseurl + 'inventoryController/getAllInventory', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.inventoryList = res.data.data.list
						this.total = res.data.data.total
					}
					this.inventorySkuList = []
					this.tableLoading1 = false
				}
			)
		},
		matchingAjax1() {
			this.tableLoading1 = true
			for (var i = 0; i < this.sondata.productInfos.length; i++) {
				var skus = this.sondata.productInfos[i].sku
				this.inventorySkuList.push(skus)
			}
			var obj = {
				companyId: this.str.company_id,
				inventorySkuList: this.inventorySkuList,
				page: this.currentPage1,
				size: this.size1,
			}
			ajaxPost(
				Baseurl + 'inventoryController/getInventoryBySku',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.inventoryList1 = res.data.data.list
					this.total1 = res.data.data.total
				}
				this.inventorySkuList = []
				this.tableLoading1 = false
			})
		},
		matchingReset() {
			this.searchString = ''
			this.matchingAjax()
		},
		handleSelectionChange1(val) {
			this.ReturninventoryLists = val
		},
		handleSelectionChange_1(val) {
			this.ReturninventoryLists1 = val
		},
		handleSelectionChange2(val) {
			this.ReturninventoryList1s = val
		},
		handleSelectionChange3(val) {
			this.tuiIdLists = val.map(x => x.id)
		},
		save() {
			var obj = {
				loginRoleId: this.str.rid,
				type: 1,
				inventorys: this.ReturninventoryLists,
				inventorys1: this.ReturninventoryLists1,
			}
			ajaxPost(
				Baseurl + 'inventoryController/insertInventoryCopy',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.innerVisibles = false
					this.inventoryAjax()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		save1() {
			var obj = {
				loginRoleId: this.str.rid,
				type: 2,
				inventorys: this.ReturninventoryList1s,
			}
			ajaxPost(
				Baseurl + 'inventoryController/insertInventoryCopy',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.Hymall = false
					this.inventoryAjax()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		inventoryAjax() {
			var obj = {
				loginRoleId: this.str.rid,
			}
			ajaxPost(
				Baseurl + 'inventoryController/selectInventoryCopyByRoleId',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.ReturninventoryList = res.data.data.inventorys
					this.ReturninventoryList1 = res.data.data.mallInventorys
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		delSave(val) {
			// console.log(val)
			var obj = {
				id: val.id,
			}
			ajaxPost(
				Baseurl + 'inventoryController/deleteInventoryCopyById',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.inventoryAjax()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		delSave1(val) {
			var obj = {
				id: val.id,
			}
			ajaxPost(
				Baseurl + 'inventoryController/deleteInventoryCopyById',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.inventoryAjax()
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		cancel() {
			this.$confirm('如果没有过提交，以上采购单将无法入库', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					loginRoleId: this.str.rid,
				}
				ajaxPost(
					Baseurl + 'inventoryController/deleteInventoryCopyByRoleId',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message('已取消提交')
					} else {
						this.$message.error(res.data.data)
					}
				})
				this.dialogTableVisible = false
			})
		},
		submit() {
			this.$alert(
				'<p>提交之后，将按照当前的采购方案进行入库核对</p><p>提交之后，该采购方案将无法更改</p><p>是否确认提交</p>',
				'提示',
				{
					dangerouslyUseHTMLString: true,
					showCancelButton: true,
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			).then(() => {
				var obj = {
					companyId: this.str.company_id,
					roleId: this.str.rid,
					purchaseDemandId: this.id,
					inventorys: this.ReturninventoryList,
					mallInventorys: this.ReturninventoryList1,
					codReturns: this.tuiTable
				}
				ajaxPost(
					Baseurl +
						'inventoryController/saveDemandInInventoryOperate',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							type: 'success',
							message: '提交成功!',
						})
						this.$emit('refresh')
					} else {
						this.$message.error(res.data.data)
					}
					this.dialogTableVisible = false
				})
			})
		},
		inventoryController() {
			var obj = {
				purchaseDemandId: this.id,
			}
			ajaxPost(
				Baseurl + 'inventoryController/selectInventoryByDemandId',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.ReturninventoryList = res.data.data.inventoryOperates
					this.ReturninventoryList1 =
						res.data.data.mallInventoryOperates
				}
			})
		},
		AddPurchasebCancel() {
			this.purchasePrice1 = ''
			this.rebatePrice1 = ''
			this.purchaseModel1 = ''
			this.logisticsCompany1 = ''
			this.purchaseTypeCode1 = ''
			this.remark1 = ''
			this.otherPrice1 = ''
			this.actualRefund1 = ''
			this.internalConveyNumber1 = ''
			this.estimatedQuantity1 = 1
			this.useQuantity1 = 1
			this.AddinnerVisible = false
		},
		LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getLogisticsCompanyList'
			).then((res) => {
				if (res.data.code == 200) {
					this.Logistics = res.data.data
				}
			})
		},
		Track17LogisticsAjax() {
			ajaxPost(
				Baseurl + 'logisticsController/getTrack17Carriers'
			).then((res) => {
				if (res.data.code == 200) {
					this.Track17Logistics = res.data.data
				}
			})
		},
		SelectLogistics1(val) {
			// console.log(val)
			this.logisticsCompany1 = val.logisticsCompanyName
			this.companyCode1 = val.logisticsCompanyCode
		},
		SelectTrack17Logistics1(val) {
			if(val) {
				this.logisticsCompany1 = val.nameCn
				this.companyCode1 = val.key
			}
		},
		SelectLogistics(val) {
			// console.log(val)
			this.logisticsCompany = val.logisticsCompanyName
			this.companyCode = val.logisticsCompanyCode
		},
		SelectTrack17Logistics(val) {
			// console.log(val)
			if(val) {
				this.logisticsCompany = val.nameCn
				this.companyCode = val.key
			}
		},
		HXShops() {
			this.Hymall = true
			this.tableLoading2 = true
			this.HXShopsSearch()
		},
		HXShopsSearch() {
			this.tableLoading2 = true
			var obj = {
				page: 1,
				size: 1000,
				searchString: this.ShopsString,
			}
			ajaxPost(
				Baseurl + 'inventoryController/selectOnLineInventorysList',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.GoodsMall = res.data.data.list
				}
				this.tableLoading2 = false
			})
		},
		HXShopsReset() {
			this.ShopsString = ''
			this.HXShopsSearch()
		},
		handleSizeChange(val) {
			this.size = val
			this.matchingAjax()
		},
		handleCurrentChange(val) {
			this.currentPage = val
			this.matchingAjax()
		},
		handleSizeChange1(val) {
			this.size1 = val
			this.matchingAjax1()
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val
			this.matchingAjax1()
		},
		handleSizeChange2(val) {
			this.size2 = val
			this.handleTuiTable()
		},
		handleCurrentChange2(val) {
			this.currentPage2 = val
			this.handleTuiTable()
		},
	},
}
</script>

<style lang="scss" scoped>
/deep/ {
	.el-dialog__body {
		padding: 13px 20px;
	}
	.el-input-group__append,
	.el-input-group__prepend {
		padding: 0 10px !important;
	}
	.logistics .el-input__inner {
		border-radius: 0px 4px 4px 0px !important;
	}
}
.line-height {
	line-height: 35px;
}
.padding {
	padding: 10px 0;
}
img {
	width: 100%;
	height: 100%;
}
.product {
	margin-top: 25px;
	width: 100%;
	// height: 200px;
	display: flex;
	.product-info{
		flex: 1;
		margin-left: 20px;
		// display: flex;
		// justify-content: space-between;
		.right{
			// width: 100px;
		}
		.title{
			display: flex;
			align-items: center;
		}
		.linkto{
			max-width: 80%;
			height: 32px;
			line-height: 32px;
			display: inline-block;
			overflow: hidden;
		}
		.info{
			span:nth-child(1){
				// margin-right: 50px;
			}
		}
	}
}
.linkto {
	color: #409eff;
}
.leix {
	background-color: #f5f7fa;
	line-height: 30px;
	padding: 5px;
	border-left: 1px solid #e4e7ed;
	border-bottom: 1px solid #e4e7ed;
	border-top: 1px solid #e4e7ed;
	color: #909399;
	border-radius: 4px 0px 0px 4px;
}
.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.details_left {
  width: 30%;
  text-align: center;
}
.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.purchase-content{
	.purchase-row{
		display: flex;
		align-items: center;
		margin-bottom: 5px;
		.item{
			display: flex;
			align-items: center;
			margin-right: 10px;
			min-width: 150px;
			&.url{
				width: 100px;
				min-width: auto;
			}
			&.num{
				width: 80px;
				min-width: auto;
			}

			.label{
				white-space: nowrap;
			}
		}
	}
}
.dialog-title1{
	display: flex;
	align-items: center;
	.title1{
		font-size: 18px;
	}
	.el-button{
		margin-left: 500px;
	}
}
.el-input__suffix-inner{
	.el-button{
		padding-left: 0;
		padding-right: 0;
	}
}
/deep/ .purchase-url-input input{
	padding-right: 170px !important;
}
.group-data-box{
	margin-top: 10px;
	.group-row{
		.group-title{
			display: flex;
			align-items: center;
			margin-bottom: 10px;
			div{
				margin-right: 10px;
			}
		}
	}
}
.success-text{
	color: #329700;
	font-weight: bold;
}
.error-text{
	color: #b30000;
	font-weight: bold;
}
.sku-title{
	display: flex;
	align-items: center;
}
.use-block{
	background-color: #e9e9e9;
}
.mr40{
	margin-right: 40px;
}
</style>
